import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '@store/authStore';
import {
  resolvePostLoginDestination,
  shouldStayOnLoginForFreshSignIn,
} from '@utils/authRouting';
import authService from '@services/authService';

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard for public pages (redirects if already authenticated)
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuthStore();
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get('returnUrl');

  if (isAuthenticated && !shouldStayOnLoginForFreshSignIn(searchParams)) {
    const storedUser = user || authService.getStoredUser();
    return <Navigate to={resolvePostLoginDestination(storedUser, returnUrl)} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
